<template>
	<div class="wrapper">
		<div class="shop-container">
			<div class="nav">
				<router-link to="home">首页</router-link>
				<span>></span>
				<!-- <span>我的订单</span> -->
				<span>{{navName}}</span>
			</div>
			<div class="main">
				<div class="l bgw">
					<div class="list-wrap" v-for="(item,index) in options" :key="index">
						<h3 class="title">{{item.title}}</h3>
						<ul>
							<li v-for="(nav,i) in item.list" :key="i">
								<router-link :to="{path:nav.route}">{{nav.name}}</router-link>
								<!-- <a @click="toNav(nav)">{{nav.name}}</a> -->
							</li>
						</ul>
					</div>
				</div>
				<div class="r">
					<div class="bgw">
						<div class="top-head">{{topHead}}</div>
						<router-view></router-view>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "Center",
		components: {},
		props: {},
		data() {
			return {
				options: [{
						title: "个人中心",
						list: [{
								name: "我的个人中心",
								route: "/center/user"
							},
							{
								name: "我的收藏",
								route: "/center/favourite"
							},
							{
								name: "我的足迹",
								route: "/center/footmark"
							},
							/* {
								name: "我的阳光积分",
								route: "/center/point"
							}, */
							// {
							//   name: "我的余额",
							//   route: "/center/balance"
							// },
							{
								name: "我的优惠券",
								route: "/center/coupon"
							}
						]
					},
					{
						title: "订单中心",
						list: [{
								name: "我的订单",
								route: "/center/myorder"
							},
							{
								name: "申请退换货",
								route: "/center/refund"
							},
							{
								name: "竞拍列表",
								route: "/center/auctioncenter"
							}
						]
					},

					{
						title: "个人信息",
						list: [
							// {
							//   name: "站内信",
							//   route: "/center/order"
							// },
							{
							  name: "资料设置",
							  route: "/center/userInfo"
							},
							// {
							//   name: "安全中心",
							//   route: "/center/safeCenter"
							// },
							{
								name: "收货地址",
								route: "/center/address"
							}
						]
					}
				],
				navName: "我的个人中心"
			};
		},
		watch: {},
		computed: {
			topHead() {
				for (let i = 0; i < this.options.length; i++) {
					const list = this.options[i].list;
					for (let index = 0; index < list.length; index++) {
						if (list[index].route == this.$route.path) {
							return list[index].name;
						} else {
							return this.$route.meta.title;
						}
					}
				}
			}
		},
		methods: {
			toNav(nav) {
				this.navName = nav.name
				this.$router.push(nav.route)
			},
			getInviteActivityDetail() {
				this.$api.getInviteActivityDetail({}).then(res => {
					if (res.status && res.data) {
						const personalCenter = this.options.find(item => item.title === '个人中心');
						if (personalCenter && !personalCenter.list.some(nav => nav.route === '/center/invite')) {
							personalCenter.list.push({
								name: "邀请活动",
								route: "/center/invite"
							});
						}
					}
				});
			}
		},
		created() {},
		mounted() {
			this.getInviteActivityDetail();
		}
	};
</script>
<style lang="scss" scoped>
	@import "@/assets/css/mixin.scss";
	@import "@/assets/css/variable.scss";

	.wrapper {
		.nav {
			@include line-height(40px);
			font-size: 12px;

			span {
				padding: 0 4px;
				font-size: #757575;
			}

			a:hover {
				color: #000;
			}
		}

		.main {
			display: flex;
			margin-bottom: 20px;

			.l {
				width: 234px;
				margin-right: 20px;
				padding: 40px 0;

				.list-wrap {
					margin-bottom: 20px;

					.title {
						padding-left: 48px;
						height: 40px;
						line-height: 40px;
						font-size: 16px;
						color: #333;
					}

					ul {
						li {
							padding-left: 54px;
							height: 32px;
							line-height: 32px;
							color: #757575;

							a:hover {
								color: $theme-color;
							}

							a.router-link-active {
								color: $theme-color;
							}

							a {
								cursor: pointer;
							}
						}
					}
				}
			}

			.r {
				flex: 1;

				.bgw {
					padding: 24px;
					min-height: 600px;
				}
			}
		}
	}
</style>
<style lang="scss">
	.top-head {
		font-size: 24px;
		font-weight: 400;
		line-height: 40px;
		color: #757575;
		margin-bottom: 10px;
	}
</style>
